<div class="sentiment-details-trend-cohort">
  <div class="sentiment-details-trend-cohort__header">
    <div class="sentiment-details-trend-cohort__tabs">
      <button type="button" class="sentiment-details-trend-cohort__tab" [class.sentiment-details-trend-cohort__tab--active]="activeTab === 'trend'" (click)="setTab('trend')">Trend</button>
      <button type="button" class="sentiment-details-trend-cohort__tab" [class.sentiment-details-trend-cohort__tab--active]="activeTab === 'cohort'" (click)="setTab('cohort')">Cohort-wise break-up</button>
    </div>
    <!-- Trend tab: time period dropdown — ngModel keeps the native select display in sync with parent (plain [value] often shows the first option while the API uses the real model). -->
    <select
      *ngIf="activeTab === 'trend'"
      class="sentiment-details-trend-cohort__dropdown"
      [ngModel]="timePeriod"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onPeriodChange($event)"
    >
      <option *ngFor="let o of timePeriodOptions" [value]="o.value">{{ o.label }}</option>
    </select>
    <!-- Cohort tab: cohort type dropdown -->
    <select
      *ngIf="activeTab === 'cohort'"
      class="sentiment-details-trend-cohort__dropdown"
      [ngModel]="cohortFilter"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onCohortFilterChange($event)"
    >
      <option *ngFor="let o of cohortFilterOptions" [value]="o.value">{{ o.label }}</option>
    </select>
  </div>
  <div class="sentiment-details-trend-cohort__body">
    <ng-content></ng-content>
  </div>
</div>
